import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Paginator.scss'

const Paginator = ({ pagesCount, currentPage }) => {
    let pages = Array.from({ length: pagesCount }, (_, i) => (
        <div
            className={classNames(styles.page, i === currentPage && styles.page_active )}
            key={i}
        />
    ))

    return (
        <div className={styles.base}>
            {pages}
        </div>
    )
}

Paginator.propTypes = {
    pagesCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
}

export default Paginator


// WEBPACK FOOTER //
// ./containers/ClanLanding/components/Paginator/Paginator.jsx